import MerchantList from '@/components/merchant/MerchantList'

const MerchantsPage = () => {
  return <MerchantList />
}

export default MerchantsPage
